import { css } from "@emotion/css";
import { CircularProgress } from "@octopusdeploy/design-system-components";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
interface CircularProgressBarProps {
    percentage: number;
    circularProgressBarUrgency: CircularProgressBarUrgency;
}
type CircularProgressBarUrgency = "danger" | "attention" | "info";
export default function CircularProgressBar({ percentage, circularProgressBarUrgency }: CircularProgressBarProps) {
    return (<div>
            <div className={style(circularProgressBarUrgency).circularProgressContainerInner}>
                <CircularProgress size="container" determinate value={percentage}/>
                <CircularProgress size="container" determinate value={100}/>
            </div>
        </div>);
}
const style = (urgency: CircularProgressBarUrgency) => {
    return {
        circularProgressContainerInner: css({
            position: "relative",
            width: "38px",
            height: "38px",
            "& > div": {
                position: "absolute",
            },
            "& > div:first-child": {
                color: themeTokens.color.icon[urgency],
                zIndex: "2",
            },
            "& > div:last-child": {
                color: themeTokens.color.border.tertiary,
            },
        }),
    };
};
